import React, {useEffect, useState} from "react";
import {Button, Table} from 'semantic-ui-react'
import {useNavigate, useParams} from "react-router";
import {InvoiceLineItems} from "./InvoiceLineItems";

export default function InvoiceDetail(props) {

    const [data, setData] = useState({
        invoice: {
            invoice_id: 0,
            customer_name: "",
            invoice_number: "",
            total:0,
            balance: 0,
            invoice_line_items: []
        }, loading: true
    })

    const navigate = useNavigate()
    const {invoiceId} = useParams()

    useEffect(() => {
        document.title = 'Invoice Detail'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    const fetchData = async () => {
        const url = API_URL + '/api/private/tanker/v1/invoices/' + invoiceId;

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                setData({invoice: data, loading: false});
            });
    }

    const {invoice} = data
    return (
        <div>
            <h2>Detail {invoiceId}
                <Button basic as="a" floated='right' compact
                        content="in Zoho öffnen" icon='external'
                        labelPosition='right'
                        href={`https://invoice.zoho.com/app#/invoices/${invoice.invoice_id}`}
                        target="_blank"/></h2>
            <Table definition>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell></Table.HeaderCell>
                        <Table.HeaderCell>Value</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <tr>
                        <td>ID</td>
                        <td>{invoice.id}</td>
                    </tr>
                    <tr>
                        <td>Zoho invoice_id</td>
                        <td>{invoice.invoice_id}</td>
                    </tr>
                    <tr>
                        <td>Kunde</td>
                        <td>{invoice.customer_name}</td>
                    </tr>
                    <tr>
                        <td>Rechnungsnummer</td>
                        <td>{invoice.invoice_number}</td>
                    </tr>
                    <tr>
                        <td>Total inkl. MwSt</td>
                        <td>{invoice.total} €</td>
                    </tr>
                    <tr>
                        <td>Balance</td>
                        <td>{invoice.balance} €</td>
                    </tr>
                </Table.Body>
            </Table>
            <h3>Line Items</h3>
            <InvoiceLineItems invoiceLineItems={invoice.invoice_line_items}/>
        </div>
    )
}


